/* Velano - Judge.me metin duzeltmeleri + fotografli yorum filtresi */
(function(){
  var AY=['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
  var TARIH=/^\s*(\d{2})\/(\d{2})\/(\d{4})\s*$/;

  function duzelt(){
    var hepsi=document.querySelectorAll('.jm-text, .jdgm-rev__timestamp, time, .jm-reviewer-info__name, .jdgm-rev__author, .jm-review-widget__header *');
    for(var i=0;i<hepsi.length;i++){
      var el=hepsi[i];
      if(el.children.length||el.dataset.vlOk) continue;
      var t=el.textContent, m=TARIH.exec(t);
      if(m){
        var ay=parseInt(m[1],10), gun=parseInt(m[2],10);
        if(ay>=1&&ay<=12&&gun>=1&&gun<=31){ el.dataset.vlOk='1'; el.textContent=gun+' '+AY[ay-1]+' '+m[3]; continue; }
      }
      if(t.trim()==='Anonymous'){ el.dataset.vlOk='1'; el.textContent='Anonim'; continue; }
      if(/değerlendirmeler\s*$/.test(t)){ el.dataset.vlOk='1'; el.textContent=t.replace(/değerlendirmeler(\s*)$/,'değerlendirme$1'); continue; }
    }
  }

  /* --- Fotografli yorum filtresi --- */
  function filtreKur(){
    var kutular=document.querySelectorAll('.jm-filters__buttons');
    for(var i=0;i<kutular.length;i++){
      var kutu=kutular[i];
      if(kutu.dataset.vlFoto) continue;
      var sel=kutu.querySelector('select.jdgm-sort-dropdown, .jm-sort-filter__select')
           || (kutu.closest('.jdgm-widget')||document).querySelector('select.jdgm-sort-dropdown, .jm-sort-filter__select');
      if(!sel) continue;
      var varMi=false;
      for(var j=0;j<sel.options.length;j++){ if(sel.options[j].value==='with_pictures') varMi=true; }
      if(!varMi) continue;

      kutu.dataset.vlFoto='1';
      var b=document.createElement('button');
      b.type='button';
      b.className='vl-foto-filtre';
      b.textContent='Fotoğraflı yorumları gör';
      b.addEventListener('click',function(ev){
        ev.preventDefault();
        var acik=this.classList.toggle('vl-foto-filtre--acik');
        this.textContent=acik?'Tüm yorumları gör':'Fotoğraflı yorumları gör';
        sel.value=acik?'with_pictures':'created_at';
        sel.dispatchEvent(new Event('change',{bubbles:true}));
      });
      kutu.appendChild(b);
    }
  }

  /* Magaza degerlendirmeleri sekmesini kaldir.
     DIKKAT: .jdgm-tablist tamamen gizlenmemeli, filtre satiri onun icinde. */
  function sekmeTemizle(){
    var tablar=document.querySelectorAll('.jdgm-tab');
    for(var i=0;i<tablar.length;i++){
      if(/Mağaza değerlendirmeleri/.test(tablar[i].textContent)) tablar[i].style.display='none';
    }
    var liste=document.querySelector('.jdgm-tablist');
    if(liste && liste.style.display==='none') liste.style.display='';
    var vp=document.querySelector('.jdgm-tablist__viewport');
    if(vp){
      var gorunur=0, t=vp.querySelectorAll('.jdgm-tab');
      for(var j=0;j<t.length;j++){ if(t[j].style.display!=='none') gorunur++; }
      if(gorunur<=1) vp.style.display='none';
    }
    var drop=document.querySelector('.jdgm-tab-dropdown');
    if(drop) drop.style.display='none';
  }

  /* Aciklama yazisini filtre satirinin altina koy */
  function aciklamaKur(){
    var kutu=document.querySelector('.jm-filters__buttons');
    if(!kutu||kutu.dataset.vlAcik) return;
    kutu.dataset.vlAcik='1';
    var s=document.createElement('span');
    s.className='vl-kanit-aciklama';
    s.textContent='Velano Concept müşterilerinin gerçek deneyimleri';
    kutu.parentElement.insertBefore(s, kutu.nextSibling);
  }

  function calis(){ duzelt(); filtreKur(); sekmeTemizle(); aciklamaKur(); }
  function baslat(){
    calis();
    var hedef=document.querySelector('.jdgm-widget-revamp')||document.body;
    try{ new MutationObserver(calis).observe(hedef,{childList:true,subtree:true}); }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',baslat); else baslat();
  setTimeout(baslat,2500); setTimeout(calis,6000);
})();
